import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PanelAdmRepository} from "@dropDesk/domain/repositories/panel_adm/panel_adm.repository";
import {ChatIntegrationConnectionEntity} from "@dropDesk/domain/entities/chat/chat_integration_connection.entity";

@injectable()
export class ChatConnectionStatePanelUseCase {
    private _repository: PanelAdmRepository;

    constructor(@inject(PanelAdmRepository) repository: PanelAdmRepository) {
        this._repository = repository;
    }

    public call(idCompany: string): Promise<ChatIntegrationConnectionEntity> {
        return this._repository.chatConnectionState(idCompany);
    }
}

